<template>
  <div class="row">
    <div class="col-xl-12 col-lg-12">
      <div>
        <div class="card">
          <div class="card-header">
            <a-button type="primary" @click="goToNew">
              + Tambah Dokter
            </a-button>
          </div>
          <div class="card-body">
            <tabel-dokter />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabelDokter from '@/components/tables/dokter'
import router from '@/router'

export default {
  components: {
    TabelDokter,
  },
  data: function () {
    return {
      isAdmin: false,
    }
  },
  created() {
    this.getRole()
  },
  methods: {
    getRole() {
      const role = window.localStorage.getItem('role')
      // console.log(role)
      if (role === 'admin') {
        this.isAdmin = true
      }
    },
    goToNew() {
      router.push('/dokter/tambah')
    },
  },
}
</script>
